<template>
	<div class="fcs-bracket-challenge-manage-brackets-page">
		<div class="fcs-bracket-challenge-manage-brackets-page__content" v-if="bracket != null">
			<section class="header">
				<form action="">
					<select name="" id="" class="header__select-bracket" v-model="selectedBracket" @change="changeBracket(selectedBracket)">
						<option v-for="bracket in entry.brackets" :value="bracket.id" :key="bracket.id">{{ bracket.name }}</option>
					</select>
				</form>
				<div class="header__actions">
					<button class="header__actions--save-button" @click="checkBracketFinished">Save</button>
					<button class="header__actions--add-entry" v-if="entry.brackets.length < entry.max_brackets" @click="addBracket">Add Bracket</button>
				</div>
			</section>

			<section class="bracket">
				<div class="bracket__header">
					<div class="bracket__header--round bracket__header--first-round1">
						<p>First Round</p>
					</div>
					<div class="bracket__header--round bracket__header--second-round1">
						<p>Second Round</p>
					</div>
					<div class="bracket__header--round bracket__header--quarterfinals1">
						<p>Quarterfinals</p>
					</div>
					<div class="bracket__header--round bracket__header--semifinals1">
						<p>Semifinals</p>
					</div>
					<div class="bracket__header--round bracket__header--championship">
						<p>Championship</p>
					</div>
					<div class="bracket__header--round bracket__header--semifinals2">
						<p>Semifinals</p>
					</div>
					<div class="bracket__header--round bracket__header--quarterfinals2">
						<p>Quarterfinals</p>
					</div>
					<div class="bracket__header--round bracket__header--second-round2">
						<p>Second Round</p>
					</div>
					<div class="bracket__header--round bracket__header--first-round2">
						<p>First Round</p>
					</div>
					<div class="bracket__header--round bracket__header--spacer">
						<p></p>
					</div>
				</div>

				<div class="bracket__content">
					<div class="bracket__content--first-round1">
						<bracket-game class="game game-1" :gameData="bracket.games[0]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-2" :gameData="bracket.games[1]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-3" :gameData="bracket.games[2]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-4" :gameData="bracket.games[3]" v-on:submit-pick="submitPick"></bracket-game>
					</div>

					<div class="bracket__content--second-round1">
						<bracket-game class="game game-9" :gameData="bracket.games[8]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-10" :gameData="bracket.games[9]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-11" :gameData="bracket.games[10]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-12" :gameData="bracket.games[11]" v-on:submit-pick="submitPick"></bracket-game>
					</div>

					<div class="bracket__content--quarterfinals1">
						<bracket-game class="game game-17" :gameData="bracket.games[16]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-18" :gameData="bracket.games[17]" v-on:submit-pick="submitPick"></bracket-game>
					</div>

					<div class="bracket__content--semifinals1">
						<bracket-game class="game game-21" :gameData="bracket.games[20]" v-on:submit-pick="submitPick"></bracket-game>
					</div>

					<div class="bracket__content--championship">
						<bracket-game class="game game-23" :gameData="bracket.games[22]" v-on:submit-pick="submitPick"></bracket-game>
					</div>

					<div class="bracket__content--semifinals2">
						<bracket-game class="game game-22" :gameData="bracket.games[21]" v-on:submit-pick="submitPick"></bracket-game>
					</div>

					<div class="bracket__content--quarterfinals2">
						<bracket-game class="game game-19" :gameData="bracket.games[18]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-20" :gameData="bracket.games[19]" v-on:submit-pick="submitPick"></bracket-game>
					</div>

					<div class="bracket__content--second-round2">
						<bracket-game class="game game-13" :gameData="bracket.games[12]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-14" :gameData="bracket.games[13]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-15" :gameData="bracket.games[14]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-16" :gameData="bracket.games[15]" v-on:submit-pick="submitPick"></bracket-game>
					</div>

					<div class="bracket__content--first-round2">
						<bracket-game class="game game-5" :gameData="bracket.games[4]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-6" :gameData="bracket.games[5]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-7" :gameData="bracket.games[6]" v-on:submit-pick="submitPick"></bracket-game>
						<bracket-game class="game game-8" :gameData="bracket.games[7]" v-on:submit-pick="submitPick"></bracket-game>
					</div>

					<div class="bracket-not-available" v-if="bracket.games[0].participants.length == 0">
						<p>The bracket isn't out yet! You'll be able to make your picks as soon as the comnittee releases the bracket on Sunday, November 24th.</p>
					</div>
					<div class="score-prediction">
						<label for="score-input">Tiebreaker - Championship Game Total Points Scored</label>
						<input id="score-input" type="number" class="score-input" v-model="bracket.championship_score">
					</div>
				</div>
			</section>
		</div>

		<div class="popup" v-if="bracketNotFinished">
			<div class="popup__content">
				<p>Heads up, you're bracket is not complete!  If you continue saving, be sure to remember to come back and finish it.</p>
				<button class="font-size--medium continue-saving" @click="saveBracket">Continue Saving</button>
				<button class="font-size--medium go-back" @click="goBackToBracket">Go Back</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import { mapMutations, mapActions } from 'vuex'
	import axios from '@/axios'
	import BracketGame from '@/components/fcs-playoff-pools/BracketGame'

	export default {
		props: [ 'poolId', 'entryId' ],
		components: {
			'bracket-game': BracketGame
		},
		data() {
			return {
				entry: null,
				bracket: null,
				selectedBracket: '',
				bracketNotFinished: false,
			}
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED'
			]),
			...mapActions([
				'attemptRefresh'
			]),
			changeBracket(id) {
				this.getBracket(id)
			},
			checkBracketFinished() {
				this.bracket.games.forEach(game => {
					if(game.game_pick == null) {
						this.bracketNotFinished = true;
					}
				})

				if(this.bracketNotFinished) {
					return
				} else {
					this.saveBracket()
				}

				
			},
			addBracket() {
				this.HTTP_IN_PROGRESS()
				axios.post('fcs-bracket-challenges/'.concat(this.poolId).concat('/fcs-bracket-challenge-entry/').concat(this.entryId).concat('/fcs-bracket-challenge-bracket')).then(() => {
					this.getEntry().then(() => {
						this.getBracket(this.entry.brackets[this.entry.brackets.length - 1].id)
					})
				})
				
				
			},
			saveBracket() {
				this.bracketNotFinished = false
				this.HTTP_IN_PROGRESS()
				axios.put('fcs-bracket-challenges/'.concat(this.poolId).concat('/fcs-bracket-challenge-entry/').concat(this.entryId).concat('/fcs-bracket-challenge-bracket/').concat(this.selectedBracket), { data: this.bracket }).then(response => {
					this.bracket = response.data.data
					this.bracket.games.forEach(element => {
							if(element.game_pick != null) {
								if((element.bracket_game_number > 8 && element.bracket_game_number%2 == 0) && element.bracket_game_number < 23) {
									Vue.set(this.bracket.games[element.bracket_number_next_game - 1].previous_game_picks, 1,  element.game_pick.participant)
								} else if((element.bracket_game_number > 8 && element.bracket_game_number%2 != 0) && element.bracket_game_number < 23) {
									Vue.set(this.bracket.games[element.bracket_number_next_game -1].previous_game_picks, 0,  element.game_pick.participant)
								}
							}
						})
						this.HTTP_FINISHED()
				}).catch(() => {
					this.HTTP_FINISHED()
				})
			},
			goBackToBracket() {
				this.bracketNotFinished = false
			},
			getBracket(bracketId) {
				this.HTTP_IN_PROGRESS()
				axios.get('fcs-bracket-challenges/'.concat(this.poolId).concat('/fcs-bracket-challenge-entry/').concat(this.entryId).concat('/fcs-bracket-challenge-bracket/').concat(bracketId)).then(response => {
						this.bracket = response.data.data
						this.selectedBracket = this.bracket.id
						this.bracket.games.forEach(element => {
							if(element.game_pick != null) {
								if((element.bracket_game_number > 8 && element.bracket_game_number%2 == 0) && element.bracket_game_number < 23) {
									Vue.set(this.bracket.games[element.bracket_number_next_game - 1].previous_game_picks, 1,  element.game_pick.participant)
								} else if((element.bracket_game_number > 8 && element.bracket_game_number%2 != 0) && element.bracket_game_number < 23) {
									Vue.set(this.bracket.games[element.bracket_number_next_game -1].previous_game_picks, 0,  element.game_pick.participant)
								}
							}
						})
						this.HTTP_FINISHED()
				})

			},
			getEntry() {
				this.HTTP_IN_PROGRESS()
				return axios.get('fcs-bracket-challenges/'.concat(this.poolId).concat('/fcs-bracket-challenge-entry/').concat(this.entryId)).then(response => {
					this.entry = response.data.data
					this.selectedBracket = this.entry.brackets[0].id
				})
			},
			submitPick(data) {
				if(data.pick.id == null) {
					return
				}
				this.bracket.games[data.gameNumber -1].game_pick = {
					participant: data.pick
				}
				if((data.gameNumber <= 8 || data.gameNumber%2 == 0) && data.gameNumber < 23) {
					Vue.set(this.bracket.games[data.nextGame -1].participants, 1,  data.pick)
				} else if((data.gameNumber > 8 && data.gameNumber%2 != 0) && data.gameNumber < 23) {
					Vue.set(this.bracket.games[data.nextGame -1].participants, 0,  data.pick)
				}

				this.bracket.games.forEach(element => {
					if(element.bracket_game_number > data.gameNumber) {
						if(element.participants[0].id == data.otherParticipant.id) {
							Vue.set(element.participants, 0, {
								id: null,
								seed: null,
								elminated: null,
								team: {
									id: null,
									name: null,
									short_name: null,
									nickname: null
								}

							})
						}
						if(element.previous_game_picks[0].id == data.otherParticipant.id) {
							Vue.set(element.previous_game_picks, 0, {
								id: null,
								seed: null,
								elminated: null,
								team: {
									id: null,
									name: null,
									short_name: null,
									nickname: null
								}

							})
						}
						if(element.participants[1].id == data.otherParticipant.id) {
							Vue.set(element.participants, 1, {
								id: null,
								seed: null,
								elminated: null,
								team: {
									id: null,
									name: null,
									short_name: null,
									nickname: null
								}
							})
						}
						if(element.previous_game_picks[1].id == data.otherParticipant.id) {
							Vue.set(element.previous_game_picks, 1, {
								id: null,
								seed: null,
								elminated: null,
								team: {
									id: null,
									name: null,
									short_name: null,
									nickname: null
								}
							})
						}
						if(element.game_pick != null) {
							if(element.game_pick.participant.id == data.otherParticipant.id) {
								element.game_pick = null
							}
						}
					}
				})
			}
		},
		created() {
			this.getEntry().then(() => {
				this.getBracket(this.entry.brackets[0].id)
			}).catch(() => {
				this.HTTP_FINISHED()
				this.$router.replace('/')
			})
			
		}
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../styles/views/fcs/fcs-bracket-challenge/manageBrackets';
</style>